import React, { useState } from "react";
import {
  ArrowLeft,
  ArrowRight,
  Building2,
  Headphones,
  RefreshCw,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import AppButton from "../../components/common/appButton/AppButton";
import { BASE_URL } from "../../config/config";
import { message } from "antd";
import axios from "axios";

const Otp = () => {
  const navigate = useNavigate();

  const [otpValue, setOtpValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // This can later come from signup/login state
  const location = useLocation();
  const email = location.state?.email;
  const role = location.state?.role;
  const from = location.state?.from;
  const handleVerify = async () => {
    if (otpValue.length !== 6) {
      setError("Please enter the 6-digit verification code.");
      return;
    }
    setError("");
    try {
      setLoading(true);

      const payload = {
        email,
        otp: otpValue,
      };
      const isAccountCreation = from === "accountCreation";
const rolePrefix = role === "customer" ? "investor" : "owner";

const endpoint = isAccountCreation
  ? `/${rolePrefix}/verify-otp`
  : `/${rolePrefix}/login/verify-otp`;

const response = await axios.post(`${BASE_URL}${endpoint}`, payload);

if (response) {
  if (isAccountCreation) {
    message.success("Account Created Successfully");
    navigate("/login");
  } else {
    if(role === "customer"){
      if(!response?.data?.registration_completed){
        message.info("Please Complete your Registration")
        navigate("/customer/register/complete-registration",{
            state: {
              token: response?.data?.access_token || "",
              email:email,
              role: "customer",
            },
          })
      }else{
        message.success("Login Successful");
        localStorage.setItem("rwatoken", response?.data?.access_token);
        localStorage.setItem("userRole", role);
        window.location.replace("/customer/home");
      }
    }else if(role === "owner"){
      if(!response?.data?.registration_completed){
        message.info("Please Complete your Registration")
        navigate("/agent/register/complete-registration",{
            state: {
              token: response?.data?.access_token || "",
              email:email,
              role: "owner",
            },
          })
      }else{
        message.success("Login Successful");
        localStorage.setItem("rwatoken", response?.data?.access_token);
        localStorage.setItem("userRole", role);
        window.location.replace("/agent/home");
      }
    }else{
       message.success("Login Successful");
        localStorage.setItem("rwatoken", response?.data?.access_token);
        localStorage.setItem("userRole", role);
        window.location.replace("/mainAdmin/home");
    }
  //   const homeRoutes = {
  //   customer: "/customer/home",
  //   owner: "/owner/home",
  //   admin: "/admin/home",
  // };

  // window.location.replace(homeRoutes[role]);
  }
}
    } catch (error) {
      console.log("OTP verification failed:", error);
      setError("The verification code is incorrect. Please try again.");
      message.error(error?.response?.data?.detail || "Something Went Wrong")
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (otp) => {
    setOtpValue(otp);

    if (error) {
      setError("");
    }

    // Optional: automatically verify when 6 digits are entered
    if (otp.length === 6) {
      // handleVerify();
    }
  };

  const handleResend = () => {
    setOtpValue("");
    setError("");

    console.log("Resend OTP");

    // RESEND OTP API HERE
  };

  return (
    <main className="min-h-screen w-full bg-[#fdfbf5] text-[#1f2318]">
      <section className="flex min-h-screen w-full">
        {/* LEFT EDITORIAL PANEL */}
        <div className="relative hidden w-[55.5%] overflow-hidden lg:block">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage:
                'url("https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1600&q=85")',
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1b2815]/10 via-[#172114]/20 to-[#172114]/80" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#132012]/15 via-transparent to-[#132012]/10" />

          {/* Logo */}
          <div className="absolute left-8 top-8 z-10 flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/95 shadow-lg">
              <Building2 size={17} strokeWidth={2.2} className="text-[#4c7a2e]" />
            </div>
            <span className="font-['Playfair_Display'] text-[19px] font-semibold tracking-[-0.02em] text-white">
              {/* Terra */}
            </span>
          </div>

          {/* UAE badge */}
          <div className="absolute right-8 top-8 z-10 rounded-full border border-white/25 bg-white/10 px-4 py-2 text-[9px] font-semibold uppercase tracking-[0.14em] text-white backdrop-blur-xl">
            UAE Real Estate
          </div>

          {/* Editorial content */}
          <div className="absolute bottom-9 left-9 right-9 z-10">
            <div className="mb-3 inline-flex items-center rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.16em] text-[#e3ecd6] backdrop-blur-xl">
              Secure verification
            </div>

            <h1 className="max-w-[600px] font-['Playfair_Display'] text-[48px] font-medium leading-[0.98] tracking-[-0.035em] text-white xl:text-[54px]">
              One step closer to
              {/* <span className="block italic font-normal text-[#dce8ce]">
                your Terra journey.
              </span> */}
            </h1>

            <p className="mt-4 max-w-[470px] text-[12px] leading-[1.7] text-[#fff] text-white/72">
              Verify your identity securely and continue to your UAE real-estate
              experience.
            </p>

            <div className="mt-7 flex max-w-[520px] items-center rounded-2xl border border-white/15 bg-black/20 px-5 py-3.5 backdrop-blur-xl">
              <div className="flex-1">
                <p className="text-[8px] font-bold uppercase tracking-[0.16em] text-white/45">
                  Protected
                </p>
                <p className="mt-1 text-[11px] font-medium text-white/90">
                  Secure account verification
                </p>
              </div>
              <div className="h-7 w-px bg-white/15" />
              <div className="px-5 text-center">
                <p className="font-['Playfair_Display'] text-[18px] text-white">
                  6
                </p>
                <p className="text-[8px] uppercase tracking-[0.12em] text-white/45">
                  Digits
                </p>
              </div>
              <div className="h-7 w-px bg-white/15" />
              <div className="pl-5 text-center">
                <p className="font-['Playfair_Display'] text-[18px] text-white">
                  UAE
                </p>
                <p className="text-[8px] uppercase tracking-[0.12em] text-white/45">
                  Platform
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT VERIFICATION PANEL */}
        <div className="relative flex min-h-screen w-full flex-1 items-center justify-center bg-white px-6 py-8 sm:px-10 lg:w-[44.5%] lg:px-14 xl:px-20">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="absolute left-6 top-7 z-10 inline-flex items-center gap-1.5 rounded-full border border-[#e1e5df] bg-white px-3.5 py-2 text-[10px] font-medium text-[#657064] shadow-[0_4px_16px_rgba(47,68,36,0.05)] transition hover:border-[#b8caa8] hover:text-[#4c7a2e] sm:left-10 lg:left-14"
          >
            <ArrowLeft size={13} strokeWidth={1.8} />
            Back
          </button>

          <div className="w-full max-w-[470px] pt-10">
            <div className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-[#eef4e8] px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.14em] text-[#5d7c3d]">
              <span className="h-1.5 w-1.5 rounded-full bg-[#6fa142]" />
              Verification
            </div>

            <div className="mb-7">
              <h2 className="font-['Playfair_Display'] text-[24px] font-medium leading-[1.02] tracking-[-0.03em] text-[#1f2318] sm:text-[38px]">
                Verify your Email 
                {/* <span className="block font-['Playfair_Display'] font-medium text-[#4c7a2e] text-[40px]">
                  email address
                </span> */}
              </h2>

              <p className="mt-4 max-w-[390px] text-[12px] leading-[1.7] text-[#899087]">
                We've sent a 6-digit verification code to your email address.
                Enter it below to continue.
              </p>

              <p className="mt-2 break-all text-[12px] font-semibold text-[#375c20]">
                {email}
              </p>
            </div>

            <div className="rounded-[18px] border border-[#e1e5df] bg-[#fdfdfb] p-5 shadow-[0_18px_50px_rgba(47,68,36,0.07)] sm:p-7">
              <div>
                <p className="mb-3 text-[9px] font-bold uppercase tracking-[0.14em] text-[#7c8876]">
                  Enter verification code
                </p>

                <OtpInput
                  value={otpValue}
                  onChange={handleOtpChange}
                  numInputs={6}
                  shouldAutoFocus
                  inputType="tel"
                  isInputNum
                  containerStyle={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "clamp(6px, 1.8vw, 12px)",
                    width: "100%",
                  }}
                  renderInput={(props, index) => (
                    <input
                      {...props}
                      key={index}
                      autoComplete={index === 0 ? "one-time-code" : "off"}
                      inputMode="numeric"
                      aria-label={`Verification digit ${index + 1}`}
                      style={{
                        width: "clamp(38px, 9vw, 52px)",
                        height: "clamp(48px, 11vw, 58px)",
                        fontSize: "clamp(19px, 4vw, 25px)",
                        fontWeight: "600",
                        borderRadius: 10,
                        padding: 0,
                        textAlign: "center",
                        color: "#1f2318",
                        background: "#ffffff",
                        border: "1px solid #dfe5da",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                  )}
                />

                {error && (
                  <p className="mt-3 rounded-lg bg-[#fdf0ee] px-3 py-2 text-[10px] font-medium leading-4 text-[#b45850]">
                    {error}
                  </p>
                )}
              </div>

              <div className="mt-6">
                <AppButton
                  type="button"
                  loading={loading}
                  disabled={otpValue.length !== 6}
                  onClick={handleVerify}
                >
                  <span>Verify & Continue</span>
                  <ArrowRight size={15} strokeWidth={2} className="ml-1.5" />
                </AppButton>
              </div>

              <div className="mt-6 text-center">
                <p className="text-[10px] text-[#92968e]">
                  Didn't receive the code?
                </p>

                <button
                  type="button"
                  onClick={handleResend}
                  className="mt-2 inline-flex items-center gap-1.5 text-[11px] font-semibold text-[#4c7a2e] transition hover:text-[#375c20]"
                >
                  <RefreshCw size={12} strokeWidth={2} />
                  Resend code
                </button>
              </div>

              <div className="my-6 h-px bg-[#e8ece5]" />

              <p className="text-center text-[9px] leading-4 text-[#92968e]">
                For your security, never share your verification code with
                anyone.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Otp;
